import { render, staticRenderFns } from "./TaskToolbar.vue?vue&type=template&id=3c75d7f3"
import script from "./TaskToolbar.vue?vue&type=script&lang=js"
export * from "./TaskToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports